// extracted by mini-css-extract-plugin
module.exports = {"canvasWrapper":"_3QuRIP9YJSFeQlQ2uZMLU-","canvas":"_1yjhbDyZMQd_AiEx19nSHg"};